import { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { CardIcon } from "../../Layout/Common/CardIcon";

export const BankTransferPayOnline = ({ handleOnCheck, TotalAmount, orderId }) => {
  const { selectedPaymentType } = useContext(GlobalContext);

  // ✅ Handle object or primitive safely
  const amount = typeof TotalAmount === "object" ? TotalAmount?.TotalAmount : TotalAmount;

  return (
    <div className="payment-card-list shipPayment">
      <div className="shipping-method savedCards-details">
        <div className="shipping-method-info pay-option" data-group={1} data-type="bankTransfer" id="pay-account">
          <div>
            <input
              className="form-check-input"
              type="radio"
              name="paymentMethod"
              id="banktransfer"
              value="BT"
              onChange={() => handleOnCheck("BT")}
              checked={selectedPaymentType === "BT"}
            />
          </div>
          <label className="form-check-label" htmlFor="banktransfer">
            Bank Transfer
          </label>
        </div>

        <p>
          <CardIcon cardType="acc-pay" alt="account" />
        </p>
      </div>

      {/* ✅ Show only when selected */}
      <div
        className="banktransfer"
        style={{
          display: selectedPaymentType === "BT" ? "block" : "none",
        }}
      >
        <div style={{ marginTop: "20px" }}>
          <div
            className="payment_contents"
            style={{
              paddingBottom: "20px",
              float: "left",
              width: "50%",
            }}
          >
            <h2
              style={{
                color: "#0099DA",
                paddingRight: "22px",
                fontSize: "13px",
                fontWeight: "bold",
              }}
            >
              Payment Required
            </h2>

            <p
              style={{
                fontSize: "13px",
                lineHeight: "1.5",
                paddingRight: "45px",
                color: "#555",
              }}
            >
              Your order is on hold awaiting payment
              <br />
              Thank you for your recent order. Payment is required prior to shipping.
              <br />
              Please transfer funds as per details shown on the right.
            </p>
          </div>

          <div
            className="trans_detail"
            style={{
              paddingBottom: "20px",
              float: "left",
              width: "40%",
            }}
          >
            <div
              className="r_box"
              style={{
                width: "350px",
                border: "5px solid red",
                padding: "20px",
                textAlign: "left",
                fontFamily: "Arial",
              }}
            >
              <h3 style={{ color: "red", margin: 0 }}>Bank Transfer Details</h3>

              <p style={{ fontSize: "13px" }}>
                <b>Total Amount :</b> $<span className="LabelStyle">{amount ?? 0}</span>
                <br />
                <b>Payment Reference :</b> WES-
                <span className="LabelStyle">{orderId}</span>
                <br />
                <b>BSB :</b> 062-105 <br />
                <b>Account No :</b> 1006-4018 <br />
                <b>Account Name :</b> WES Components Pty Ltd <br />
                <b>Swift / BIC Code :</b> CTBAAU2S <br />
              </p>

              <p style={{ fontSize: "12px", marginBottom: "0px" }}>
                Important.
                <br />
                Please include the shown payment reference
                <br />
                as your payment description for fast processing.
              </p>
            </div>
          </div>

          <div style={{ clear: "both" }} />
        </div>
      </div>
    </div>
  );
};
